/**
 * Flattens react-hook-form errors object into an array of error items
 * Each item contains the path and message
 *
 * @param {Object} errors - The errors object from formState.errors
 * @param {string} parentPath - Internal parameter for recursion
 * @returns {Array<{path: string, message: string}>} Array of error items
 */
export const getAllErrorItems = (errors, parentPath = "") => {
  const items = [];

  if (!errors || typeof errors !== "object") {
    return items;
  }

  Object.keys(errors).forEach((key) => {
    const value = errors[key];
    const isArrayIndex = !isNaN(key);
    const currentPath = parentPath
      ? isArrayIndex
        ? `${parentPath}.[${key}]`
        : `${parentPath}.${key}`
      : key;

    // If value is an object/array without a message, recurse
    if (typeof value === "object" && value !== null && !value.message) {
      items.push(...getAllErrorItems(value, currentPath));
    }
    // If value has a message, it's a leaf error
    else if (value?.message) {
      items.push({
        path: currentPath,
        message: value.message,
      });
    }
  });

  return items;
};
